import {Redirect, Route, useHistory} from 'react-router-dom';
import {IonApp, IonRouterOutlet, setupIonicReact} from '@ionic/react';


import React, {Suspense, useEffect} from 'react';
import {App, URLOpenListenerEvent} from '@capacitor/app';
import {connect} from 'react-redux';
import get from "lodash/get";
import {store} from "../configureStore";


import {setPushToken, setResetToken} from "../actions/Auth";
import {acceptingAnInvite} from "../thunks/Auth";


const AppUrlListener: React.FC<{ setPushToken: any, acceptingAnInvite: any, setResetToken: any,   isAuthenticated: any }> = ({
                                                                                                         setPushToken,
                                                                                                         acceptingAnInvite,
                                                                                                         isAuthenticated,
                                                                                                         setResetToken
                                                                                                     }) => {
    let history = useHistory();


    useEffect(() => {
        App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
            // Example url: https://beerswift.app/tabs/tab2
            // slug = /tabs/tab2
            try {

                const url = new URL(event.url);
                if (url.href.indexOf('restore') != -1 && url.searchParams.get('token')) {
                    //нам пришел запрос на сброс пароля, редиректим на страницу задания нового пароля
                    let token = url.searchParams.get('token');
                    setResetToken(token);
                    history.push(`/auth/reset-password`);
                }

                if (url.href.indexOf('acceptInvite') != -1 && url.searchParams.get('inviteToken')) {
                    //нам  пришел запрос на принятие инвайта. Принимаем его и показываем тост о том что у нас все получилось, или не получилось
                    let authToken = url.searchParams.get('inviteToken');
                    acceptingAnInvite(authToken,isAuthenticated);
                }
            } catch (e) {

            }
            // If no match, do nothing - let regular routing
            // logic take over
        });

    }, [])


    return null
}


const mapStateToProps = state => ({
    isAuthenticated: state.Auth.isAuthenticated,
});


const mapDispatchToProps = dispatch => ({
    setPushToken: (message) => dispatch(setPushToken(message)),
    acceptingAnInvite: (token,isAuthed) => dispatch(acceptingAnInvite(token,isAuthed)),
    setResetToken: (resetToken) => dispatch(setResetToken(resetToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppUrlListener);


